import BasicInfo from "./pages/basic-info";
import ResetPassword from "./pages/reset-password";
import Dashboard from "./pages/dashboard";

export default [
  {
    path: "/profile",
    component: Dashboard,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "info",
        component: BasicInfo,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "reset-password",
        component: ResetPassword,
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];
